var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HTTPService } from "./http.service";
import { assign, filter, findIndex, forEach, map } from "lodash-es";
import { planLengthsFixed, planTypesFixed, speedTiersFixed } from './fixed-details.data';
var PlansDetailService = /** @class */ (function (_super) {
    __extends(PlansDetailService, _super);
    function PlansDetailService() {
        var _this = _super.call(this) || this;
        _this.apiBase = window.hasOwnProperty('api_url') ? window.api_url : "/api";
        _this.speedTiers = speedTiersFixed;
        _this.planTypes = planTypesFixed;
        _this.planLengths = planLengthsFixed;
        // Data for `most_popular_options` is output in app.blade.php by a view composer
        if (window.most_popular_options) {
            var most_popular = window.most_popular_options;
            _this.setMostPopular(most_popular);
        }
        return _this;
    }
    // Set most popular contract length from ACF data
    PlansDetailService.prototype.setMostPopular = function (most_popular) {
        var _this = this;
        if (most_popular.hasOwnProperty('contract_length') && most_popular.contract_length) {
            forEach(Object.keys(this.planLengths), function (technology) {
                var index = findIndex(_this.planLengths[technology], { name: most_popular.contract_length });
                if (index < 0) {
                    return;
                }
                _this.planLengths[technology][index].is_popular = true;
            });
        }
        if (most_popular.hasOwnProperty('plan_type') && most_popular.plan_type) {
            forEach(Object.keys(this.planTypes), function (technology) {
                var index = findIndex(_this.planTypes[technology], { code: most_popular.plan_type });
                if (index < 0) {
                    return;
                }
                _this.planTypes[technology][index].is_popular = true;
            });
        }
        if (most_popular.hasOwnProperty('speed_tiers') && most_popular.speed_tiers) {
            forEach(Object.keys(this.speedTiers), function (technology) {
                map(most_popular.speed_tiers, function (speed_tier) {
                    if (_this.speedTiers[technology].hasOwnProperty(speed_tier)) {
                        _this.speedTiers[technology][speed_tier].is_popular = true;
                    }
                });
            });
        }
    };
    PlansDetailService.prototype.plansForSpeedTier = function (technology, speedTier) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!speedTier) {
                throw new Error("plansForSpeedTier: speed_tier is required");
            }
            _this.formPost("".concat(_this.apiBase, "/plans_for_speed_tier"), {
                technology: technology,
                speed_tier: speedTier
            }).then(function (response) {
                var plans = response.data.plans;
                map(plans, function (plan) {
                    if (plan && plan.details.contract_length === null) {
                        plan.details.contract_length = '30days';
                    }
                });
                resolve(plans);
            }).catch(function (response) {
                reject([]);
            });
        });
    };
    PlansDetailService.prototype.getServiceQualification = function (addressId) {
        return this.formPost("".concat(this.apiBase, "/service_qualification"), {
            address_id: addressId
        });
    };
    PlansDetailService.prototype.getSpeedTiers = function (technology, addressId, contractLength, planType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var data = {
                technology: technology
            };
            if (addressId && !isNaN(addressId)) {
                data.address_id = addressId;
            }
            _this.formPost("".concat(_this.apiBase, "/speed_tiers"), data)
                .then(function (response) {
                var formattedData = [];
                if ("speeds" in response.data) {
                    forEach(response.data.speeds, function (speed) {
                        if (_this.speedTiers[technology][speed.speed_tier] != undefined) {
                            var newSpeed = assign({}, speed, _this.speedTiers[technology][speed.speed_tier]);
                            // Filter by contract_length if specified
                            // NOTE: Speed tier data from API has no contract lengths :\
                            if ((newSpeed.is_disabled) ||
                                (contractLength && newSpeed.contract_length !== contractLength) ||
                                (planType && newSpeed.plan_type !== planType)) {
                                return;
                            }
                            formattedData.push(newSpeed);
                            return;
                        }
                        formattedData.push(__assign({ title: speed.speed_tier }, speed));
                    });
                    resolve(formattedData);
                }
                else {
                    reject("No plan speeds returned");
                }
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    PlansDetailService.prototype.getContractLengths = function (technology) {
        if (this.planLengths.hasOwnProperty(technology)) {
            return this.planLengths[technology];
        }
        return [];
    };
    PlansDetailService.prototype.getPlanTypes = function (technology) {
        if (planTypesFixed.hasOwnProperty(technology)) {
            return filter(planTypesFixed[technology], function (planType) { return !(planType.hasOwnProperty('is_disabled') && planType.is_disabled); });
        }
        return [];
    };
    PlansDetailService.prototype.getCISLink = function (technology, speedTier, planID) {
        return "".concat(this.apiBase, "/broadband_cis?service_type=").concat(technology, "&tier=").concat(speedTier, "&plan=").concat(planID, "&bundled=0");
    };
    PlansDetailService.prototype.getKFSLink = function (technology, speedTier, planID) {
        return "".concat(this.apiBase, "/kfs?service_type=").concat(technology, "&tier=").concat(speedTier, "&plan=").concat(planID, "&bundled=0");
    };
    return PlansDetailService;
}(HTTPService));
export { PlansDetailService };
export var plansDetailService = new PlansDetailService();
